module.exports = __webpack_public_path__ + "static/media/finsite_basic.72f2f380.png";